import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { axiosInstance } from "../../utils/axiosInstance";

// Fetch feature list
//?page_no=${pagination.page}&page_size=${pagination.size}

export const fetchFeatureList = createAsyncThunk(
  "featureList/fetchData",
  async (params: {
    feature_name: string[];
    feature_description: string[];
    group_name: string[];
    appId: number;
    pageNumber: number;
    pageSize: number;
  }) => {
    const response = await axiosInstance.post(
      `/featsetup/featurefilter?appId=${params.appId}&page_no=${params.pageNumber}&page_size=${params.pageSize}`,
      {
        feature_name: params?.feature_name || [],
        feature_description: params.feature_description || [],
        group_name: params.group_name || [],
      },
    );
    return response.data;
  },
);

// Fetch feature group list

export const fetchFeatureGroupList = createAsyncThunk(
  "featureGroupList/fetchData",
  async () => {
    const response = await axiosInstance.get("/featsetup/featuregroups");
    return response.data.data;
  },
);

export type featureList = featureListObject[];

export interface featureListObject {
  id: number;
  total_count: number;
  feature_name: string;
  feature_description: string;
  group_name: string;
  group_id: number;
  permissionId: number[];
}
export interface createFeatureObj {
  id: number;
  feature_name: string;
  feature_description: string;
  group_id: number[];
  app_id: number;
  group_name: string[];
  permissionId: number[];
  visibleToRoles: boolean;
  allowedRoles: string[];
}
export type featureGroupList = featureGroupListObject[];

export interface featureGroupListObject {
  id: number;
  group_name: string;
  group_id: number;
}

export type featureListState = {
  data: featureList;
  totalListCount: number;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  groupData: featureGroupList;
  groupStatus: "idle" | "loading" | "succeeded" | "failed";
  groupError: string | null;
  editData: featureListObject;
  saveData: createFeatureObj;
};
const initialState: featureListState = {
  data: [],
  totalListCount: 0,
  status: "idle",
  error: null,
  groupData: [],
  groupStatus: "idle",
  groupError: null,
  editData: {
    id: 0,
    feature_name: "",
    feature_description: "",
    group_name: "",
    group_id: 0,
    total_count: 0,
    permissionId: [],
  },
  saveData: {
    id: 0,
    feature_name: "",
    feature_description: "",
    group_id: [],
    app_id: 0,
    group_name: [],
    permissionId: [],
    visibleToRoles: true,
    allowedRoles: [],
  },
};

const featureListSlice: any = createSlice({
  name: "featureList",
  initialState,
  reducers: {
    editFeatureData: (state, action: PayloadAction<featureListObject>) => {
      state.editData = action.payload;
    },
    saveFeatureData: (state, action: PayloadAction<createFeatureObj>) => {
      state.saveData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchFeatureList.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = "succeeded";
          state.data = action.payload.data;
          state.totalListCount = Number.isNaN(
            Number(action.payload?.data[0]?.total_count),
          )
            ? 0
            : Number(action.payload?.data[0]?.total_count);
        },
      )
      .addCase(fetchFeatureList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      })
      .addCase(fetchFeatureGroupList.pending, (state) => {
        state.groupStatus = "loading";
      })
      .addCase(
        fetchFeatureGroupList.fulfilled,
        (state, action: PayloadAction<featureGroupList>) => {
          state.groupStatus = "succeeded";
          state.groupData = action.payload;
        },
      )
      .addCase(fetchFeatureGroupList.rejected, (state, action) => {
        state.groupStatus = "failed";
        state.groupError = action.error.message || null;
      });
  },
});

export const selectFeatureList = (state: RootState) => state.featureList;
export const { editFeatureData, saveFeatureData } = featureListSlice.actions;
export default featureListSlice.reducer;
